import http from "@/core/services/http.service";
import {NORWAY_POST_CODE_SEARCH_PROVIDER, UK_POST_CODE_SEARCH_PROVIDER} from "@/modules/constants";
import {store} from './../../plugins/vuex/index'
import i18n from "@/shared/i18n";

class PostCodeHelperService {
  static getInfoByPostCode(params) {
    if ([NORWAY_POST_CODE_SEARCH_PROVIDER, UK_POST_CODE_SEARCH_PROVIDER].includes(store.state.global.postCodeSearchProvider)) {
      return http.get('/api/v1/post-codes/search/', {params});
    }
    return new Promise((next) => {
      next({
        success: false,
        body: {
          non_field_errors: [
            i18n.t("Post Code Search Provider is not configured.")
          ]
        }
      })
    })
  }

  static getInfoByAddress(params) {
    if ([UK_POST_CODE_SEARCH_PROVIDER].includes(store.state.global.postCodeSearchProvider)) {
      return http.get('/api/v1/post-codes/address-search/', {params});
    }
    return new Promise((next) => {
      next({
        success: false,
        body: {
          non_field_errors: [
            i18n.t("Post Code Search Provider is not configured.")
          ]
        }
      })
    })
  }
}

export {
  PostCodeHelperService
};
